<template>
	<div id="app" @click="isDo()" ref="vueDom" style="display:none">
		<div class="dontent">
			<router-view v-if="isRouter" />
		</div>
		<!--    <footer-nav></footer-nav>-->
	</div>
</template>

<script>
import { getLink, getVirtyalUser, getOpenRecord } from "@comm/api/document-conversion";
import { getToken, setToken } from "@comm/utils/auth";
import { getBrowerInfo } from "@comm/utils/useAgent";
import { getParam } from "@comm/utils/tools";
export default {
	name: "App",
	components: {},
	provide() {
		return {
			// reload: this.reload,
			token: ""
		};
	},
	data() {
		return {
			isRouter: true,
			_beforeUnload_time: "",
			_gap_time: "",
			lastTime: null, //最后一次点击的时间
			currentTime: null, //当前点击的时间
			timeOut: 10 * 60 * 1000, //设置超时时间： 10分钟
			quitTIme: "",
			path: "",
			winLink:""
		};
	},
	mounted() {
		this.path = this.$route.path;
		window.addEventListener("offline", () => {
			this.$message.error("网络异常，请检查网络");
			// location.reload();
		});
		window.addEventListener("online", () => {
			// location.reload();
		});
		window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
		window.addEventListener("unload", (e) => this.unloadHandler(e));
		let that = this;
		setTimeout(() => {
			that.$refs.vueDom.style.display = 'block'
		}, 1000)
		this.quitTIme = window.setInterval(this.overTime, 1000);
		//用户变化屏幕方向时调用
		if (this.judgeClient() != "PC")
			window.addEventListener(
				"onorientationchange" in window ? "orientationchange" : "resize",
				() => {
					// that.screenOrient();
					// location.reload();
				},
				false
			);
	},
	destroyed() {
		window.removeEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
		window.removeEventListener("unload", (e) => this.unloadHandler(e));
	},
	methods: {
		getLinkUrl() {
			getLink().then((res) => {
				if (res.data.length > 0) {
					let winLink = res.data[0].lconUrl;
					let andLink = res.data[2].lconUrl;
					let sdkLink = res.data[3].lconUrl;
					this.winLink = winLink;
					localStorage.setItem("winLink", winLink);
					localStorage.setItem("andLink", andLink);
					localStorage.setItem("sdkLink", sdkLink);
				}
			});
		},
		getuseToken() {
			getVirtyalUser().then((res) => {
				if (!res.data) {
					return;
				}
				this.token = res.data;
				setToken(this.token);


			});
		},
		reload() {
			this.isRouter = false;
			this.$nextTick(function () {
				this.isRouter = true;
			});
		},
		beforeunloadHandler(e) {
			this._beforeUnload_time = new Date().getTime();
		},
		unloadHandler(e) {
			this._gap_time = new Date().getTime() - this._beforeUnload_time;
			//判断是窗口关闭还是刷新
			if (this._gap_time <= 5) {
				getOpenRecord({
					openType: 1
				}).then((res) => {
					if (!res.data) {
						return;
					}
				});
			}
		},
		overTime() {
			let that = this;
			this.currentTime = new Date().getTime(); // 记录当前点击的时间
			if (this.currentTime - this.lastTime > this.timeOut) {
				//判断上次最后一次的点击时间和最新的点击时间间隔时候大于30分钟
				clearInterval(that.quitTIme);
				that.quitTIme = "";
			}
		},
		isDo() {
			clearInterval(this.quitTIme);
			this.quitTIme = "";
			this.lastTime = new Date().getTime();
			this.quitTIme = window.setInterval(this.overTime, 1000);
		},
		//判断屏幕方向
		screenOrient() {
			let calcBasis = "width";
			if (window.orientation == 90 || window.orientation == -90) {
				calcBasis = "height";
			} else if (window.orientation == 0 || window.orientation == 180) {
				calcBasis = "width";
			}
		},
		/*判断客户端*/
		judgeClient() {
			let client = "";
			if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				//判断iPhone|iPad|iPod|iOS
				client = "iOS";
			} else if (/(Android)/i.test(navigator.userAgent)) {
				//判断Android
				client = "Android";
			} else {
				client = "PC";
			}
			return client;
		}
	},
	created: function () {
		if (
			navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
		) {
			if (this.$route.name != "readering" && this.$route.name != "readPage" && this.$route.name != "shareReadPage") {
				if (window.screen.availWidth < 768) {

					document.write('<meta name="viewport" content="initial-scale=0.26, maximum-scale=1">');
				} else {
					document.write('<meta name="viewport" content="initial-scale=0.48, maximum-scale=1">');
				}
			} else {
				document.write('<meta name="viewport" content="initial-scale=1, maximum-scale=1">');
			}
			localStorage.setItem("isPhone", true);
			this.screenOrient();
		} else {
			//PC端CSS
			localStorage.setItem("isPhone", false);
		}
		if(!localStorage.winLink){
			this.getLinkUrl();
		}
		
		this.lastTime = new Date().getTime();
		// this.token = sessionStorage.getItem("token");
		const { browserType, browserVersion } = getBrowerInfo();
		sessionStorage.setItem("browserType", browserType);
		sessionStorage.setItem("brwoserVersion", browserVersion);
	}
};
</script>

<style lang="scss">
html,
body,
#app {
	height: 100%;
}

#app {
	font-weight: 400;
	color: #333;
	font-size: 14px !important;
	overflow-y: auto;
	overflow-x: hidden;
	position: relative;
}

.dontent {
	height: 100%;
}

.el-button--primary {
	background-color: #14a8f0;
	border-color: #14a8f0;
}

.el-dialog__header {
	text-align: left;
	font-size: 18px;
	color: #242f44;
	padding: 18px 24px 24px;
}

.el-dialog {
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.fail_box {
	.el-dialog__header {
		padding: 18px 24px 12px;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		height: 434px;
		max-height: 434px;
		max-width: 420px;
		margin: 50px 0 20px !important;
	}

	.el-dialog__body {
		flex: 1;
	}
}

.el-dialog .el-dialog__body {
	overflow: auto;
	padding: 0 24px 64px;
}

.el-dialog__footer {
	padding: 0 20px 20px;
}

.el-dialog .el-dialog__body .content {
	text-align: left;
	color: #4f5d79;
	line-height: 22px;
}

.changephone_box.merge {
	.el-dialog__header {
		padding: 24px;
	}

	.el-dialog__footer {
		padding-bottom: 24px;
	}
}

.customDialog .el-dialog__body {
	display: flex;
	padding: 0 !important;
}

.customDialog .el-tabs__nav-wrap::after {
	display: none;
}

.customDialog .el-tabs__item.is-active {
	color: #14A8F0;
	background: #fff;
}

.customDialog .el-tabs--left .el-tabs__item.is-left {
	text-align: left;
	width: 138px;
	padding-right: 10px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	outline: none;
}

.customDialog .el-tabs--left .el-tabs__active-bar.is-left {
	right: auto;
	left: 0;
}

/*清除text文本输入框的清除图标*/
input::-ms-clear {
	display: none;
}

/*清除password密码输入框的明文图标*/
input::-ms-reveal {
	display: none;
}

.sample-dialog .el-dialog__body {
	padding-bottom: 0;
}
.attestationDialog{
	overflow: hidden!important;
	.el-dialog__header,.el-dialog__title{
		font-size: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/supubwps-document-conversion/App.vue